import { call, put } from "redux-saga/effects";
import { getStore, getOffer } from "../../api/storeApi";
import { Types } from "../actionTypes";

export function* doStore(action) {
  try {
    const response = yield call(getStore, action.params);
    if (response.response && response.response.status !== 200) {
      throw response;
    }
    if (!response.store_key) {
      yield put({ type: Types.FETCH_STORE_LOCATION_FAILURE });
      console.warn("The store for this deal was not found", response);
    }

    // for the map, to have a location pre-selected
    const { selectedLocationKey } = action.params;

    if (!!selectedLocationKey) {
      let { closest_location, locations } = response;

      if (closest_location.location_id !== selectedLocationKey) {
        const selectedLocationIndex = locations.findIndex(
          (location) => location.location_id === selectedLocationKey,
        );
        if (selectedLocationIndex > -1) {
          const tempLocation = { ...closest_location };
          response.closest_location = { ...locations[selectedLocationIndex] };
          response.locations[selectedLocationIndex] = tempLocation;
        }
      }
    }

    yield put({ type: Types.FETCH_STORE_LOCATION_SUCCESS, response });
  } catch (e) {
    yield put({
      type: Types.FETCH_STORE_LOCATION_FAILURE,
      response: e,
    });
    if (e.data?.message === "SESSION_EXPIRED") {
      yield put({ type: Types.SET_SESSION_EXPIRED });
    } else {
      console.error("STORE ERROR: " + JSON.stringify(e));
    }
  }
}

export function* doOffer(action) {
  try {
    const response = yield call(getOffer, action.params);

    yield put({ type: Types.FETCH_OFFER_KEY_SUCCESS, response });
  } catch (e) {
    yield put({ type: Types.FETCH_OFFER_KEY_FAILURE, e });
    if (e.data?.message === "SESSION_EXPIRED") {
      yield put({ type: Types.SET_SESSION_EXPIRED });
    } else {
      console.log("error: ", e);
    }
  }
}
